export default __webpack_public_path__ + "static/icon-bar-a-96ae4d6b42e810e8e517d2c9408a0ba7.png";